module.exports = __webpack_public_path__ + "static/media/ONLINEP99.e1e8b7ce.png";